import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { combineLatest, Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { map, take } from "rxjs/operators";
import {
  SsoAccountFacade,
  SessionStorageKey,
  SessionStorageState,
  AgreementSigningStatus,
  IdentityVerificationAction,
} from "common";


@Injectable({
  providedIn: "root",
})
export class ApplicationAgreementSignedGuard implements CanActivate {
  constructor(
    private ssoAccountFacade: SsoAccountFacade,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (SessionStorageState.get(SessionStorageKey.ApplicationAgreementViewed)) {
      return true;
    }

    return combineLatest([
      this.ssoAccountFacade.getSsoAccountCheckoutState$(), 
      this.ssoAccountFacade.getCurrentSsoAccount$()
    ])
    .pipe(
      take(1),
      map(([checkoutState, currentAccount]) => {
        const pendingApplication = currentAccount?.pendingApplications?.find(
          app => app.agreementSigningStatus === AgreementSigningStatus.PendingCurrentUser
        );

        if (pendingApplication && checkoutState.identityVerificationAction === IdentityVerificationAction.Skip) {
          this.router.navigate([
            `application/${pendingApplication.applicationId}/setup/sign-agreement`,
          ]);
          return false;
        }

        return true;
      })
    );
  }
}
